module.exports = __webpack_public_path__ + "img/State of Palestine.60118859.svg";